import { render, staticRenderFns } from "./info.vue?vue&type=template&id=72a4c39f&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a4c39f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a4c39f')) {
      api.createRecord('72a4c39f', component.options)
    } else {
      api.reload('72a4c39f', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=72a4c39f&scoped=true", function () {
      api.rerender('72a4c39f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Category/info.vue"
export default component.exports